import { FC } from 'react';

import { RecipientModalState } from '../utils/delivery.types';

interface Props {
  modal: RecipientModalState;
  setModal: React.Dispatch<React.SetStateAction<RecipientModalState | null>>;
  onSave: () => Promise<void>;
}

const inputClassName =
  'mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500';

export const RecipientEditModal: FC<Props> = ({ modal, setModal, onSave }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50" onClick={() => setModal(null)} />
      <div className="relative w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
        <h3 className="text-lg font-bold text-gray-900">수령인 정보 수정</h3>
        <p className="mt-1 text-xs text-gray-500">
          발주 전 수령인 및 배송지 정보를 수정할 수 있습니다.
        </p>

        <div className="mt-4 space-y-3">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">수령인</label>
              <input
                type="text"
                value={modal.name}
                onChange={(e) =>
                  setModal((prev) => (prev ? { ...prev, name: e.target.value } : null))
                }
                className={inputClassName}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">연락처</label>
              <input
                type="text"
                value={modal.phoneNumber}
                onChange={(e) =>
                  setModal((prev) =>
                    prev ? { ...prev, phoneNumber: e.target.value } : null,
                  )
                }
                placeholder="01012345678"
                className={inputClassName}
              />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700">우편번호</label>
              <input
                type="text"
                value={modal.postalCode}
                onChange={(e) =>
                  setModal((prev) =>
                    prev ? { ...prev, postalCode: e.target.value } : null,
                  )
                }
                className={inputClassName}
              />
            </div>
            <div className="col-span-2">
              <label className="block text-sm font-medium text-gray-700">주소</label>
              <input
                type="text"
                value={modal.address}
                onChange={(e) =>
                  setModal((prev) => (prev ? { ...prev, address: e.target.value } : null))
                }
                className={inputClassName}
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">상세주소</label>
            <input
              type="text"
              value={modal.addressDetail}
              onChange={(e) =>
                setModal((prev) =>
                  prev ? { ...prev, addressDetail: e.target.value } : null,
                )
              }
              className={inputClassName}
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end gap-2">
          <button
            onClick={() => setModal(null)}
            className="rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            취소
          </button>
          <button
            disabled={modal.isSaving}
            onClick={async () => {
              await onSave();
            }}
            className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {modal.isSaving ? '저장 중...' : '저장'}
          </button>
        </div>
      </div>
    </div>
  );
};
